import type { CredentialResponseType } from '@@/types/types'

export default defineNuxtRouteMiddleware(async () => {
  const appleAuthData = useCookie<CredentialResponseType | null>(
    'apple-auth-data',
  )
  const googleAuthData = useCookie<CredentialResponseType | null>(
    'google-auth-data',
  )
  if (!appleAuthData.value && !googleAuthData.value) return

  const { loginWithProviderHandle } = await useAuthProvider()

  if (googleAuthData.value)
    await loginWithProviderHandle('google', googleAuthData.value)

  if (appleAuthData.value)
    await loginWithProviderHandle('apple', appleAuthData.value)

  googleAuthData.value = null
  appleAuthData.value = null
})
